// extracted by mini-css-extract-plugin
export default {"paginateClass":"eDkQkBYS","paginateUI":"whSBiSjQ","positionDescription":"yU_1wSW4","buttons":"Mm8N7jLk","disable":"A6WmTb7W","enable":"hTG0cWdv"};